import axios from 'axios';
import config from '../config';

const transferService = {
    // Transfer arama API çağrısı
    searchTransfers: async (searchParams) => {

        try {
            const userData = JSON.parse(localStorage.getItem('user_data'));
            const {
                transferType,
                fromCoordinates,
                toCoordinates,
                departureDate,
                returnDate,
                adults,
                children
            } = searchParams;

            // API parametrelerini hazırla
            const params = {
                transfer_type: transferType === 'round-trip' ? 'multiple_way' : 'single_way',
                from_coordinates: `${fromCoordinates.lat},${fromCoordinates.lng}`,
                to_coordinates: `${toCoordinates.lat},${toCoordinates.lng}`,
                departure_date: departureDate,
                adult: adults,
                child: children
            };

            // Round trip ise return date ekle
            if (transferType === 'round-trip' && returnDate) {
                params.return_date = returnDate;
            }

            const response = await axios.get(`${config.API_BASE_URL_V1}transfers/search`, {
                params: params,
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${userData?.token}`,
                    'Accept': 'application/json'
                }
            });
            return response.data;
        } catch (error) {
            console.error('Transfer service error:', error);
            
            // Hata durumunda kullanıcı dostu mesaj
            if (error.response) {
                // Check if response is HTML (React app response)
                const responseType = error.response.headers['content-type'];
                if (responseType && responseType.includes('text/html')) {
                    throw new Error('API Configuration Error: Request is being sent to React app instead of API server. Check API_BASE_URL_V1 configuration.');
                }
                
                throw new Error(`API Error (${error.response.status}): ${error.response.data?.message || error.response.statusText}`);
            } else if (error.request) {
                throw new Error('Network Error: Unable to connect to the transfer service. Please check your internet connection.');
            } else {
                throw new Error(`Request Error: ${error.message}`);
            }
        }
    },

    // Transfer detaylarını getir
    getTransferDetails: async (transferId) => {
        try {
            const userData = JSON.parse(localStorage.getItem('user_data'));
            const response = await axios.get(`${config.API_BASE_URL_V1}transfers/${transferId}`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${userData?.token}`,
                    'Accept': 'application/json'
                }
            });

            return response.data;
        } catch (error) {
            console.error('Transfer details error:', error);
            throw error;
        }
    }
};

export default transferService; 